;
/*!
 * jquery.photocollants.slider.js
 */

;(function ( $, undefined ) {


	// Create the defaults, only once!
	var defaults = {
		propertyName: "value"
	};

	// The actual plugin constructor
	function PhotocollantsSlider ( element ) {
		this.element = element;
		this.options = $.extend( {}, defaults, this.options );

		this.init();
	}

	PhotocollantsSlider.prototype = {

		init      : function () {
			var _this = this;


			_this.$elem = $( this.element );
			if ( _this.$elem.length < 1 ) {
				return;
			}


			_this.$sliderItemsContainer = _this.$elem.find( '.pc-group-items' );

			console.log("$sliderItemsContainer", _this.$sliderItemsContainer);
			_this.$sliderItems = _this.$sliderItemsContainer.find( '.pc-group-item' );
			_this.$likesContainer = _this.$sliderItems.find( '.pc-item-likes' );
			_this.$headerSection = _this.$elem.find( '.pc-group-header' );
			_this.$slickArrowsContainer = _this.$headerSection.find( '.slick-arrows-container' );

			_this.$slickArrowPrev = _this.$elem.find( '.slick-prev' );
			_this.$slickArrowNext = _this.$elem.find( '.slick-next' );

			_this.fingerprint;
			_this.visitorExistingVotes = [];
			_this.groupId = _this.$elem.data( 'pc-group-id' );
			_this.cookieName = 'photocollants-likes';


			_this.readExistingCookie();

			_this.addHearts();

			// Only one in group? No slick;
			if ( _this.$sliderItems.length > 1 ) {
				_this.setupSlick();
			}



			new Fingerprint2( {
				excludeAvailableScreenResolution: true,
				excludeScreenResolution         : true
			} ).get( function ( result, components ) {
				_this.fingerprint = result;
			} );


			_this.bindEvents();


		},
		addHearts : function () {
			var _this = this;

			_this.$likesContainer.prepend( $( '<div class="heart-container" role="presentation" aria-hidden="true">' + _this.svgHeart + '</div>' ) );
		},
		setupSlick: function () {
			var _this = this;
			//console.log('setupSlick', _this.$elem);

			_this.$sliderItemsContainer.on( 'init', function ( slick ) {
				var $currentSlide = $(this).find( '.slick-current' ).eq( 0 ),
					offset = $currentSlide.find( '.pc-group-item-inner' ).offset().top - _this.$headerSection.offset().top - _this.$slickArrowPrev.outerHeight();

				_this.$slickArrowsContainer.css( {
					top: offset
				} );

			} );

			// _this.$sliderItemsContainer.imagesLoaded( function () {

				 _this.$sliderItemsContainer.slick( {
					'prevArrow': _this.$slickArrowPrev,
					'nextArrow': _this.$slickArrowNext,
					'slide' : '#' + _this.$elem.attr('id') + ' .pc-group-item'
				} );


				_this.$sliderItemsContainer.on( 'afterChange', function ( event, slick, currentSlide, nextSlide ) {
					var $currentSlide = $( slick.$slides.get( currentSlide ) ),
						$slideHeader = $currentSlide.find( '.pc-item-submitter' ),
						offset = $currentSlide.find( '.pc-group-item-inner' ).offset().top - _this.$headerSection.offset().top - _this.$slickArrowPrev.outerHeight();

					_this.$slickArrowsContainer.css( {
						top: offset
					} );

				} );

			// } );
		},
		svgHeart  : '<svg class="likes-heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 92.37"><defs><style>.heart-shape{fill:#04b7db;}</style></defs><path class="heart-shape" d="M100,29.94A29.93,29.93,0,0,0,50.38,7.39L50,7l-0.38.38A29.93,29.93,0,0,0,7.39,49.62l-0.07.07L50,92.37,92.68,49.69l-0.07-.07A29.81,29.81,0,0,0,100,29.94Z"/></svg>',


		bindEvents        : function () {
			var _this = this;

			_this.$likesContainer.on( 'click', function ( e ) {
				var $this = $( this ),
					isActive = !$this.hasClass( 'inactive' );


				if ( isActive ) {
					_this.submitVote( $this );
				}

			} );

		},
		submitVote        : function ( $clicked ) {
			var _this = this;

			var photocollantId = $clicked.parents( '.pc-group-item' ).data( 'pc-id' ),
				alreadyVotedForThisOne = $.inArray( photocollantId, _this.visitorExistingVotes ) !== -1;

			//console.log( photocollantId, alreadyVotedForThisOne, _this.visitorExistingVotes );

			if ( !alreadyVotedForThisOne && photocollantId && typeof CONFIG != 'undefined' && typeof CONFIG.photocollants_vote_url != 'undefined' ) {

				var dataToSend = {
					action         : 'photocollantVote',
					photocollant_id: photocollantId,
					fingerprint    : _this.fingerprint
				};

				//console.log( 'About to vote on a Photocollant', dataToSend );

				$.ajax( {
					url   : CONFIG.photocollants_vote_url,
					data  : dataToSend,
					method: 'post'
				} )
					.done( function ( _data ) {

						var isSuccess = typeof _data.success != 'undefined' && _data.success == 1;

						if ( isSuccess ) {
							$clicked.find( '.pc-item-likes-count' ).text( _data.data );
							$clicked.addClass( 'inactive' );

							$clicked.find( '.cta-click' ).remove();

							_this.visitorExistingVotes.push( photocollantId );
							_this.saveCookie();
						}
					} );

			}
		},
		readExistingCookie: function () {
			var _this = this;

			var cookieValue = Cookies.get( _this.cookieName );

			if ( cookieValue ) {
				cookieValue = JSON.parse( cookieValue );

				for ( var i = 0; i < cookieValue.length; i++ ) {
					var vote = cookieValue[ i ];

					_this.visitorExistingVotes.push( vote );

					var $targetMeme = _this.$sliderItems.filter( '[data-pc-id="' + vote + '"]' );

					if ( $targetMeme.length > 0 ) {
						$targetMeme.find( '.pc-item-likes' ).addClass( 'inactive' );

						$targetMeme.find( '.pc-group-item-footer' ).find( '.cta-click' ).remove();
					}
				}
			}
		},
		saveCookie        : function () {
			var _this = this;

			Cookies.set( _this.cookieName, _this.visitorExistingVotes, { expires: 365 } );
		}

	}

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn.photocollantsSlider = function ( options ) {
		return this.each( function () {
			if ( !$.data( this, "PhotocollantsSlider" ) )
			{
				if (options)
				{
					$.data(this, "PhotocollantsSlider", new PhotocollantsSlider(this, options));
				}
			}
		} );
	}


})( jqPla );

